var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modalExplodedBom",
      attrs: { id: "modalExplodedBom", title: _vm.title, size: "xxl" },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "row pb-1 pt-1" }, [
            _c(
              "div",
              { staticClass: "col-sm-12 text-right" },
              [
                _c("generic-toggle", {
                  attrs: {
                    label: "Consolidate Material Lengths",
                    "size-class": "btn-sm",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.fullRefresh()
                    },
                  },
                  model: {
                    value: _vm.ignoreLength,
                    callback: function ($$v) {
                      _vm.ignoreLength = $$v
                    },
                    expression: "ignoreLength",
                  },
                }),
                _vm._v(" "),
                _c("generic-toggle", {
                  attrs: {
                    label: "Show Inline Details",
                    "size-class": "btn-sm",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.refreshItems()
                    },
                  },
                  model: {
                    value: _vm.showInlineDetails,
                    callback: function ($$v) {
                      _vm.showInlineDetails = $$v
                    },
                    expression: "showInlineDetails",
                  },
                }),
                _vm._v(" "),
                _c("generic-toggle", {
                  attrs: {
                    label: "Consolidate Setup by Catalogue # for Labor",
                    "size-class": "btn-sm",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.refreshItemsAndRecalculate()
                    },
                  },
                  model: {
                    value: _vm.consolidateSetupForLabor,
                    callback: function ($$v) {
                      _vm.consolidateSetupForLabor = $$v
                    },
                    expression: "consolidateSetupForLabor",
                  },
                }),
                _vm._v(" "),
                _c("generic-toggle", {
                  attrs: {
                    label: "Reverse Categories for Labor",
                    "size-class": "btn-sm",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.refreshItemsAndRecalculate()
                    },
                  },
                  model: {
                    value: _vm.reverseLaborCategories,
                    callback: function ($$v) {
                      _vm.reverseLaborCategories = $$v
                    },
                    expression: "reverseLaborCategories",
                  },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-card",
            { attrs: { "no-body": "" } },
            [
              _c(
                "b-tabs",
                [
                  _c("b-tab", { attrs: { title: "Exploded BOM" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 mt-2" },
                        [
                          _c("generic-table", {
                            ref: "explodedBomTable",
                            attrs: {
                              items: _vm.explodedBomMassaged,
                              "export-key": _vm.explodedExportKey,
                              fields: _vm.calculatedExplodedFields,
                              "hide-search-reset-buttons": "",
                              "per-page": _vm.pageSize,
                              "total-rows": _vm.explodedTotalRows,
                              "current-page": _vm.explodedPage,
                              "toolbar-button-size": "sm",
                            },
                            on: {
                              "update:currentPage": function ($event) {
                                _vm.explodedPage = $event
                              },
                              "update:current-page": function ($event) {
                                _vm.explodedPage = $event
                              },
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "toolbar-buttons",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-button-group",
                                      { staticClass: "mx-1 mb-1 mb-md-0" },
                                      [
                                        _c(
                                          "b-btn",
                                          {
                                            attrs: {
                                              size: "sm",
                                              variant: "primary",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.explodedBomExport()
                                              },
                                            },
                                          },
                                          [_vm._v("Export to CSV")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "row-details",
                                fn: function (row) {
                                  return [
                                    row.item.MATERIAL_NUMBER_PM
                                      ? _c(
                                          "b-card",
                                          {
                                            staticClass: "pb-1 pt-1 px-1",
                                            attrs: { "no-body": "" },
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-2" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-4 font-weight-bold",
                                                        },
                                                        [_vm._v("Mat. #")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-8",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                row.item
                                                                  .MATERIAL_NUMBER_PM
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-12",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                            " +
                                                              _vm._s(
                                                                row.item
                                                                  .MATERIAL_DESCRIPTION_PM
                                                              ) +
                                                              "\n                          "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-2" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-4 font-weight-bold",
                                                        },
                                                        [_vm._v("Cost")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-8",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatCurrencyExtreme(
                                                                row.item
                                                                  .MATERIAL_UNIT_COST_PM
                                                              )
                                                            ) +
                                                              " / " +
                                                              _vm._s(
                                                                row.item
                                                                  .MATERIAL_UOM_PM
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-3" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-4 font-weight-bold",
                                                        },
                                                        [_vm._v("Weight")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-8",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatPreciseFloat(
                                                                row.item
                                                                  .UNIT_WEIGHT_PM
                                                              )
                                                            ) + " per Inch"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-2" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-4 font-weight-bold",
                                                        },
                                                        [_vm._v("Width")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "col-sm-8",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatPreciseFloat(
                                                                row.item
                                                                  .WIDTH_PM
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "cell(BOM_LEVEL_CALC)",
                                fn: function (data) {
                                  return [
                                    _c("span", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formatExplodedLevel(
                                            data.item.BOM_LEVEL_CALC
                                          )
                                        ),
                                      },
                                    }),
                                  ]
                                },
                              },
                              {
                                key: "cell(DRAWING_NUMBER_CALC)",
                                fn: function (data) {
                                  return [
                                    _vm.state.enableDrawingLinkFlag &&
                                    data.item.DRAWING_NUMBER_CALC &&
                                    data.item.DRAWING_NUMBER_CALC.length
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: _vm.getDrawingFileLink(
                                                data.item.DRAWING_NUMBER_CALC
                                              ),
                                              target: "_blank",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickDrawingFileLink(
                                                  data.item.DRAWING_NUMBER_CALC,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  data.item.DRAWING_NUMBER_CALC
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.state.enableDrawingLinkFlag
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                data.item.DRAWING_NUMBER_CALC
                                              ) +
                                              "\n                  "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                              {
                                key: "foot(EXPLODED_RUN_TIME_CALC)",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.explodedRunTimeTotal) +
                                        "\n                "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "foot(SETUP_TIME_CALC)",
                                fn: function () {
                                  return [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.explodedSetupTimeTotal) +
                                        "\n                "
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-tab", { attrs: { title: "Flattened BOM" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 mt-2" },
                        _vm._l(
                          _vm.flattenedCategories,
                          function (flattenedCategory) {
                            return _c(
                              "b-card",
                              {
                                key: flattenedCategory.category,
                                staticClass: "mb-1",
                                attrs: { "no-body": "" },
                              },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(flattenedCategory.category) +
                                        " : " +
                                        _vm._s(flattenedCategory.bom.length) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-body",
                                  [
                                    _c("generic-table", {
                                      ref: "flattenedBomTable",
                                      refInFor: true,
                                      attrs: {
                                        items: flattenedCategory.bom,
                                        "export-key": _vm.flattenedExportKey,
                                        fields: _vm.calculatedFlattenedFields,
                                        "hide-search-reset-buttons": "",
                                        "per-page": _vm.pageSize,
                                        "total-rows":
                                          flattenedCategory.pagination
                                            .totalRows,
                                        "current-page":
                                          flattenedCategory.pagination.index,
                                        "toolbar-button-size": "sm",
                                        "get-export-data-override":
                                          _vm.flattenedBomGetExportData,
                                      },
                                      on: {
                                        "update:currentPage": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            flattenedCategory.pagination,
                                            "index",
                                            $event
                                          )
                                        },
                                        "update:current-page": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            flattenedCategory.pagination,
                                            "index",
                                            $event
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "toolbar-buttons",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-button-group",
                                                  {
                                                    staticClass:
                                                      "mx-1 mb-1 mb-md-0",
                                                  },
                                                  [
                                                    _c(
                                                      "b-btn",
                                                      {
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.flattenedBomExport()
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Export to CSV")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "cell(DRAWING_NUMBER_CALC)",
                                            fn: function (data) {
                                              return [
                                                _vm.state
                                                  .enableDrawingLinkFlag &&
                                                data.item.DRAWING_NUMBER_CALC &&
                                                data.item.DRAWING_NUMBER_CALC
                                                  .length
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.getDrawingFileLink(
                                                            data.item
                                                              .DRAWING_NUMBER_CALC
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickDrawingFileLink(
                                                              data.item
                                                                .DRAWING_NUMBER_CALC,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              data.item
                                                                .DRAWING_NUMBER_CALC
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.state.enableDrawingLinkFlag
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            data.item
                                                              .DRAWING_NUMBER_CALC
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "foot(QUANTITY_SC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatFloat(
                                                        flattenedCategory.totals
                                                          .QUANTITY_SC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(EXTENDED_TOTAL_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        flattenedCategory.totals
                                                          .EXTENDED_TOTAL_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(CUSTOM_UNIT_COST_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        flattenedCategory.totals
                                                          .AVERAGE_UNIT_COST_TOTAL_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(RUN_TIME_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatPreciseFloat(
                                                        flattenedCategory.totals
                                                          .RUN_TIME_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(SETUP_TIME_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatFloat(
                                                        flattenedCategory.totals
                                                          .SETUP_TIME_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "cell(QUANTITY_ORDERED_CALC)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.state
                                                          .currentTenantId +
                                                        "/browse/catalogues/catalogue-po-items-" +
                                                        _vm.encode(
                                                          data.item
                                                            .SUB_PART_CAT_NO_SC
                                                        ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatInt(
                                                            data.item
                                                              .QUANTITY_ORDERED_CALC
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(QUANTITY_AVAILABLE_CALC)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.state
                                                          .currentTenantId +
                                                        "/browse/mrp-" +
                                                        _vm.encode(
                                                          data.item
                                                            .SUB_PART_CAT_NO_SC
                                                        ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatInt(
                                                            data.item
                                                              .QUANTITY_AVAILABLE_CALC
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(STOCK_AVAILABLE_CALC)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.state
                                                          .currentTenantId +
                                                        "/browse/mrp-" +
                                                        _vm.encode(
                                                          data.item
                                                            .SUB_PART_CAT_NO_SC
                                                        ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatInt(
                                                            data.item
                                                              .STOCK_AVAILABLE_CALC
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-tab", { attrs: { title: "Consolidated Mfg" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 mt-2" },
                        _vm._l(
                          _vm.manufacturedCategories,
                          function (manufacturedCategory) {
                            return _c(
                              "b-card",
                              {
                                key: manufacturedCategory.category,
                                staticClass: "mb-1",
                                attrs: { "no-body": "" },
                              },
                              [
                                _c(
                                  "b-card-header",
                                  {
                                    staticClass: "p-1",
                                    attrs: {
                                      "header-tag": "header",
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(manufacturedCategory.category) +
                                        " : " +
                                        _vm._s(
                                          manufacturedCategory.bom.length
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-card-body",
                                  [
                                    _c("generic-table", {
                                      ref: "manufacturedBomTable",
                                      refInFor: true,
                                      attrs: {
                                        items: manufacturedCategory.bom,
                                        "export-key": _vm.manufacturedExportKey,
                                        fields:
                                          _vm.calculatedManufacturedFields,
                                        "hide-search-reset-buttons": "",
                                        "per-page": _vm.pageSize,
                                        "total-rows":
                                          manufacturedCategory.pagination
                                            .totalRows,
                                        "current-page":
                                          manufacturedCategory.pagination.index,
                                        "toolbar-button-size": "sm",
                                        "get-export-data-override":
                                          _vm.manufacturedBomGetExportData,
                                      },
                                      on: {
                                        "update:currentPage": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            manufacturedCategory.pagination,
                                            "index",
                                            $event
                                          )
                                        },
                                        "update:current-page": function (
                                          $event
                                        ) {
                                          return _vm.$set(
                                            manufacturedCategory.pagination,
                                            "index",
                                            $event
                                          )
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "toolbar-buttons",
                                            fn: function () {
                                              return [
                                                _c(
                                                  "b-button-group",
                                                  {
                                                    staticClass:
                                                      "mx-1 mb-1 mb-md-0",
                                                  },
                                                  [
                                                    _c(
                                                      "b-btn",
                                                      {
                                                        attrs: {
                                                          size: "sm",
                                                          variant: "primary",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.manufacturedBomExport()
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("Export to CSV")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "cell(DRAWING_NUMBER_CALC)",
                                            fn: function (data) {
                                              return [
                                                _vm.state
                                                  .enableDrawingLinkFlag &&
                                                data.item.DRAWING_NUMBER_CALC &&
                                                data.item.DRAWING_NUMBER_CALC
                                                  .length
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: _vm.getDrawingFileLink(
                                                            data.item
                                                              .DRAWING_NUMBER_CALC
                                                          ),
                                                          target: "_blank",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickDrawingFileLink(
                                                              data.item
                                                                .DRAWING_NUMBER_CALC,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              data.item
                                                                .DRAWING_NUMBER_CALC
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.state.enableDrawingLinkFlag
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            data.item
                                                              .DRAWING_NUMBER_CALC
                                                          ) +
                                                          "\n                      "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "foot(QUANTITY_SC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatFloat(
                                                        manufacturedCategory
                                                          .totals.QUANTITY_SC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(EXTENDED_TOTAL_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        manufacturedCategory
                                                          .totals
                                                          .EXTENDED_TOTAL_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(CUSTOM_UNIT_COST_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        manufacturedCategory
                                                          .totals
                                                          .AVERAGE_UNIT_COST_TOTAL_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(RUN_TIME_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatPreciseFloat(
                                                        manufacturedCategory
                                                          .totals.RUN_TIME_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "foot(SETUP_TIME_CALC)",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.formatFloat(
                                                        manufacturedCategory
                                                          .totals
                                                          .SETUP_TIME_CALC
                                                      )
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                          {
                                            key: "cell(QUANTITY_ORDERED_CALC)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.state
                                                          .currentTenantId +
                                                        "/browse/catalogues/catalogue-po-items-" +
                                                        _vm.encode(
                                                          data.item
                                                            .SUB_PART_CAT_NO_SC
                                                        ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatInt(
                                                            data.item
                                                              .QUANTITY_ORDERED_CALC
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(QUANTITY_AVAILABLE_CALC)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.state
                                                          .currentTenantId +
                                                        "/browse/mrp-" +
                                                        _vm.encode(
                                                          data.item
                                                            .SUB_PART_CAT_NO_SC
                                                        ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatInt(
                                                            data.item
                                                              .QUANTITY_AVAILABLE_CALC
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(STOCK_AVAILABLE_CALC)",
                                            fn: function (data) {
                                              return [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href:
                                                        _vm.state
                                                          .currentTenantId +
                                                        "/browse/mrp-" +
                                                        _vm.encode(
                                                          data.item
                                                            .SUB_PART_CAT_NO_SC
                                                        ),
                                                      target: "_blank",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.formatInt(
                                                            data.item
                                                              .STOCK_AVAILABLE_CALC
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }
                        ),
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("b-tab", { attrs: { title: "Flattened Labor" } }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col-sm-12 mt-2" },
                        _vm._l(_vm.laborCategories, function (laborCategory) {
                          return _c(
                            "b-card",
                            {
                              key: laborCategory.category,
                              staticClass: "mb-1",
                              attrs: { "no-body": "" },
                            },
                            [
                              _c(
                                "b-card-header",
                                {
                                  staticClass: "p-1",
                                  attrs: {
                                    "header-tag": "header",
                                    role: "tab",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(laborCategory.category) +
                                      " : " +
                                      _vm._s(
                                        _vm.formatFloat(
                                          laborCategory.totals.TOTAL_TIME_CALC
                                        )
                                      ) +
                                      " hrs : " +
                                      _vm._s(
                                        _vm.formatCurrency(
                                          laborCategory.totals.TOTAL_COST_CALC
                                        )
                                      ) +
                                      "\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-card-body",
                                [
                                  _c("generic-table", {
                                    ref: "laborTable",
                                    refInFor: true,
                                    attrs: {
                                      items: laborCategory.labor,
                                      "export-key": _vm.laborExportKey,
                                      fields: _vm.calculatedLaborFields,
                                      "hide-search-reset-buttons": "",
                                      "per-page": _vm.pageSize,
                                      "total-rows":
                                        laborCategory.pagination.totalRows,
                                      "current-page":
                                        laborCategory.pagination.index,
                                      "toolbar-button-size": "sm",
                                      "get-export-data-override":
                                        _vm.laborGetExportData,
                                    },
                                    on: {
                                      "update:currentPage": function ($event) {
                                        return _vm.$set(
                                          laborCategory.pagination,
                                          "index",
                                          $event
                                        )
                                      },
                                      "update:current-page": function ($event) {
                                        return _vm.$set(
                                          laborCategory.pagination,
                                          "index",
                                          $event
                                        )
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "toolbar-buttons",
                                          fn: function () {
                                            return [
                                              _c(
                                                "b-button-group",
                                                {
                                                  staticClass:
                                                    "mx-1 mb-1 mb-md-0",
                                                },
                                                [
                                                  _c(
                                                    "b-btn",
                                                    {
                                                      attrs: {
                                                        size: "sm",
                                                        variant: "primary",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.laborExport()
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Export to CSV")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "foot(QUANTITY_SC)",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatFloat(
                                                      laborCategory.totals
                                                        .QUANTITY_CALC
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "foot(SETUP_COST_CALC)",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatCurrency(
                                                      laborCategory.totals
                                                        .SETUP_COST_CALC
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "foot(RUN_COST_CALC)",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatCurrency(
                                                      laborCategory.totals
                                                        .RUN_COST_CALC
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "foot(TOTAL_TIME_CALC)",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatFloat(
                                                      laborCategory.totals
                                                        .TOTAL_TIME_CALC
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "foot(TOTAL_COST_CALC)",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(
                                                    _vm.formatCurrency(
                                                      laborCategory.totals
                                                        .TOTAL_COST_CALC
                                                    )
                                                  ) +
                                                  "\n                    "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("generic-confirm", {
            ref: "localFileConfirm",
            attrs: { "allows-html": "true" },
            on: { shown: _vm.localLinkModalShown },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }